

import Popup from 'vux/src/components/popup/index.vue'

import cusDateTime from '@/components/cusDateTime';


export default {
name: "search-multiply-date",
components: { Popup,cusDateTime},
data() {
return {
date: {},
dateGe: null,
dateLe: null,
wlPopup: '',
showDate: false,
}
},
props:['text'],
methods: {

showDatePop(){
this.showDate = !this.showDate;
this.dateGe = null;
this.dateLe = null;
this.getElement()
},

goBack(){
this.showDate=false;

},

closeDatePop(){
if(!this.dateGe){
this.$vux.toast.text('请选择开始日期！')
return;
}
if(!this.dateLe){
this.$vux.toast.text('请选择结束日期！')
return;
}
if(new Date(this.dateGe)-new Date(this.dateLe)>0){
this.$vux.toast.text('结束日期需要大于开始日期！')
return;
}
this.showDate=false;
this.date['dateGe']=this.dateGe;
this.date['dateLe']=this.dateLe;
this.$emit('on-confirm',this.date)
},

delDate(){
this.date=[];
this.$emit('on-clear',this.date)
},
hide(){
let popup=document.getElementById(this.wlPopup);
popup.parentElement.removeChild(this.divMask)
},

getElement(){
this.$nextTick(()=>{
let el=document.getElementsByClassName('vux-popup-mask vux-popup-show')[0];
if(el){
document.body.removeChild(el)
}
let popup=document.getElementById(this.wlPopup);
this.divMask=document.createElement('a')
this.divMask.className = 'vux-popup-mask'
this.divMask.dataset.uuid = ''
this.divMask.href = 'javascript:void(0)'
this.divMask.style.opacity=1;
this.divMask.style['z-index']=1;
this.divMask.addEventListener('click',  () =>{
this.showDate=false;
}, false)
popup.parentElement.appendChild(this.divMask)

})
}


},
mounted() {
this.wlPopup=(Math.random()+1)*10+'red';
}




}



// WEBPACK FOOTER //
// ./src/components/search-multiply-date.vue